import { IIconProps } from '~/types';

const LogoutIcon = ({ variant, ...props }: IIconProps) => {
  const getStrokeColor = () => {
    switch (variant) {
      case 'primary':
        return 'var(--t-black)';
      case 'themed':
        return 'var(--prim4)';
      case 'danger':
        return 'var(--danger)';
      case 'neutral':
        return 'var(--neut3)';
      case 'secondary':
        return 'var(--text2)';
      case 'success':
        return 'var(--success)';
      default:
        return '#313036';
    }
  };

  return (
    <svg
      width={20}
      height={18}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m15 13 4-4m0 0-4-4m4 4H5m6 4v1a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
        stroke={getStrokeColor()}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default LogoutIcon;
